const configuration = {
    instrumentationKey: process.env.REACT_APP_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
    connectionString:process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING
};

export default configuration;